import {observer} from "mobx-react";
import {DialogStore, fmsPackageDetailStore} from "../../../store";
import {ModalDialog} from "../../ui";

interface FmsModalDialogDocumentNotLocatableProps {
    store: DialogStore
}

const FmsModalDialogDocumentNotLocatable = observer(function({
    store
                                                             }: FmsModalDialogDocumentNotLocatableProps) {
    const notLocatableDialogStore = store
    return <ModalDialog
        store={notLocatableDialogStore}
        actions={[
            {
                label: "Abbrechen",
                execute: async function () {
                    fmsPackageDetailStore.selectedItem = undefined
                    notLocatableDialogStore.dialogOpen = false
                },
                className: 'is-primary is-rounded is-small'
            },
            {
                label: "Dokument markieren",
                execute: async function () {
                    notLocatableDialogStore.executing = true
                    await fmsPackageDetailStore.markSelectedItemAsNotLocatable()
                    fmsPackageDetailStore.selectedItem = undefined
                    notLocatableDialogStore.executing = false
                    notLocatableDialogStore.dialogOpen = false
                },
                className: 'is-rounded is-small'
            }
        ]}
        title={"Dokument nicht auffindbar?"}
    >
        Sind Sie sich sicher, dass Sie dieses Dokument als nicht auffindbar markieren wollen?
    </ModalDialog>
})

export {
    FmsModalDialogDocumentNotLocatable
}
